import { apiGateway } from 'api/apiHost';
import { DataFetcher, PageDataContext, PageDataResult } from './types';
import axios from 'axios';

const resolveName = (name: string, replaceValue: string) => name.replace('*', replaceValue);

export const fundDetailsDataFetcher: DataFetcher = {
  templateIds: [
    '5827425C-1B42-46D1-9F13-11387A5BD4B3', // Automation vector
    '543D5F77-8AD4-4326-9E23-84804031CB3C', // Investments vector
    '023EE573-91D8-46DC-A139-7A3EB4157AAA', // Adviser vector
    'CF3F2635-270B-4977-9BB3-822AB90F1DCC', // Personal vector
    'E3590AD7-64A8-4980-A419-C4F1F926F9FC', // Global vector
  ],

  async fetchData(context: PageDataContext): Promise<PageDataResult> {
    console.log('Fund details data fetcher');
    // Extract ISIN code from slug (last part after final dash)
    const isinCode = context.slug.split('-').at(-1);

    const {
      language,
      site: { name },
      itemPath,
      fundsConfiguration: {
        countryInvestors: { countryCode, investorType, jurisdiction, literatureAuthorization },
      },
    } = context.sitecoreContext as any;

    const calculatedLanguage =
      name === 'Intermediary' && language.toLowerCase() === 'en-us'
        ? 'en-lu'
        : language === 'en-nz'
        ? 'en-au'
        : language;

    const fundDetailsPayload = {
      CountryInvestors: {
        CountryCode: countryCode,
        InvestorType: investorType,
        Jurisdiction: jurisdiction,
        LiteratureAuthorization: literatureAuthorization,
      },
      language: calculatedLanguage,
      isin: isinCode,
    };

    try {
      const fundDetailsData = {
        data: null,
        error: false,
      };

      const { data } = await axios.post(
        `${apiGateway.host}${apiGateway.path}/funds/funddetails`,
        fundDetailsPayload,
        { headers: { 'X-API-Key': process.env.API_GATEWAY_KEY ?? '' } }
      );

      if (data) {
        fundDetailsData.data = { ...data, isinCode };
        const twitterCard = {
          ...context.sitecoreContext.twitterCard,
          twitterTitle: resolveName(
            context.sitecoreContext.twitterCard?.twitterTitle ?? '',
            data.name
          ),
        };

        const openGraph = {
          ...context.sitecoreContext.openGraph,
          ogTitle: resolveName(context.sitecoreContext.openGraph?.ogTitle ?? '', data.name),
        };

        return {
          data: {
            fundDetailsData,
          },
          pageTitle: resolveName(context.sitecoreContext.metaTitle, data.name),
          contextData: {
            ...context.sitecoreContext,
            metaTitle: resolveName(context.sitecoreContext.metaTitle, data.name),
            twitterCard,
            openGraph,
            itemPath: `${itemPath.replace(
              ',-w-,',
              data.name.toLowerCase().replaceAll(' ', '-')
            )}-${isinCode}`,
          },
        };
      }

      return {
        data: {
          fundDetailsData: {
            error: true,
            data: {},
          },
        },
      };
    } catch (e) {
      console.log('error during requesting fund details page', e);
      return {
        data: {
          fundDetailsData: {
            error: true,
            data: {},
          },
        },
      };
    }
  },
};
